import React, { FunctionComponent } from 'react';
import { Checkbox, ErrorMessage } from 'react-design-components';
import { Controller } from 'react-hook-form';
import ControlledFormComponentProps from '../ControlledFormComponentProps';
import { Terms } from '../../components';

interface FormData {
  terms?: boolean;
}

const TermsInput: FunctionComponent<ControlledFormComponentProps<FormData>> = ({ t, control, errors }) => {
  return (
    <>
      <Controller
        render={({ field: { onChange, value } }) => (
          <Checkbox onChange={onChange} value={value} label={<Terms t={t} i18nKey="terms" />} />
        )}
        name="terms"
        control={control}
        rules={{
          required: t('validation.terms.required') as string,
        }}
      />
      {!!errors.terms && <ErrorMessage>{errors.terms.message}</ErrorMessage>}
    </>
  );
};

export default TermsInput;
